import PageHeader from 'src/core/ui/PageHeader';

import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { CardType, ContentCard } from 'src/core/ui/ContentCard';
import { CustomDataGrid } from 'src/core/tables/CustomDataGrid';
import { useWarehouseValuesSummaryTable } from 'src/pages/reports/warehouse/useWarehouseReportsTable';


function WarehouseValueSummaryReportTablePage() {
    const [columns, tableSettings] = useWarehouseValuesSummaryTable();

  
    return (
        <>
            <PageHeader  {...{
                title: "Warehouse Value Summary Report",
                subTitle: "A report that shows the value in money of the items in all warehouses",
                components: [
                    // { component: <CustomButton title="New Return Order" icon={<AddTwoToneIcon />} actionUrl="/management/commerce/products/create" /> },
                ],
            }} />

            <ContentCardsContainer >
                <ContentCard {...{ cardId: "Warehouse Values Report", cardTypes: [CardType.noHeader], contentPadding: 0 }}>
                    <CustomDataGrid columns={columns} tableSettings={tableSettings} />
                </ContentCard>

             

            </ContentCardsContainer>

            <Footer />
        </>
    );
}

export default WarehouseValueSummaryReportTablePage;
